<div class="table-card recent-activity-card">
  <div class="card-header">
    <h4 class="card-title">الأسئلة الأعلى تفاعلاً</h4>
    <a class="view-all" (click)="goToQuestions()">عرض الكل</a>
  </div>

  <div class="table-responsive">
    <table class="table" aria-label="جدول الأسئلة الأعلى تفاعلاً">
      <thead>
        <tr>
          <th class="text-right">السؤال</th>
          <th class="text-right">التخصص</th>
          <th class="text-right">الخبير</th>
          <th class="text-center">الردود</th>
          <th class="text-center">الحالة</th>
        </tr>
      </thead>
      <tbody>
        @for (item of rows; track item.question) {
          <tr>
            <td class="text-right title-cell">{{ item.question }}</td>
            <td class="text-right">{{ item.specialty }}</td>
            <td class="text-right">{{ item.expert }}</td>
            <td class="text-center">{{ item.replies }}</td>
            <td class="text-center">
              @if (item.isOpen) {
                <span class="status-badge status-open">{{ item.statusLabel }}</span>
              } @else {
                <span class="status-badge status-closed">{{ item.statusLabel }}</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
